export default __webpack_public_path__ + "static/media/google-drive.9fa7c71e.svg";